import { SkipReason, isSkipReason } from "../Explore.model";

const skipReasonToLabel: Record<SkipReason, string> = {
  NO_RELEASE_FOUND: "No Release Found",
  TOPIC_NOT_RELEASED: "Topic Not Released",
  AUDIENCE_FILTER: "Audience Filter",
  NOT_SUPPORTED_ATTACHMENTS: "Not Supported Attachments",
  OUT_OF_BUSINESS_HOURS: "Out of Business Hours",
  EXCLUDED_FROM_QUACK: "Excluded From Quack",
  UNCLASSIFIED: "Unclassified",
  ERROR: "Error",
  ASSIGNED_TO_ANOTHER_AGENT: "Assigned to Another Agent",
};

export function getSkipReasonText(value: string): string {
  return isSkipReason(value) ? skipReasonToLabel[value] : "";
}

export function SkipReasonFormatter({ value }: { value: string }) {
  if (value == null || !isSkipReason(value)) {
    return <></>;
  }

  return <>{getSkipReasonText(value)}</>;
}
